/**
 * What a NEW illustration layer of an existing story takes from the story's
 * latest book: its style only. The format is not inherited — a new layer starts
 * at the current default (portrait 2:3, bookFormat.DEFAULT_BOOK_FORMAT) and the
 * parent's own pick in the wizard stands. Dev run 5 (F1): a story whose first
 * book was 4:3 got every new layer in 4:3 by default.
 */
export function extendBookDefaults(book: { style?: string | null; format?: string | null } | undefined): {
  style?: string;
} {
  return book?.style ? { style: book.style } : {};
}
